var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDownload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#0A0909"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.3 15.2l-1.8 1.9v-6.9c0-.2-.2-.4-.4-.4s-.4.2-.4.4v6.9l-1.8-1.9c-.2-.2-.4-.2-.6 0-.2.2-.2.4 0 .6l2.6 2.6c.2.2.4.2.6 0l2.6-2.6c.2-.2.2-.4 0-.6-.4-.2-.7-.2-.8 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1 21.7c0 .2-.2.4-.4.4H4.3c-.2 0-.4-.2-.4-.4V2.3c0-.2.2-.4.4-.4h9.8v4.8c0 .7.6 1.3 1.3 1.3h4.7v13.7zm-.6-14.5h-4.1c-.2 0-.4-.2-.4-.5V2.5l4.5 4.7zm1.1-.1l-5.5-5.7c-.2-.3-.6-.4-.9-.4H4.3C3.6 1 3 1.6 3 2.3v19.4c0 .7.6 1.3 1.3 1.3h15.4c.7 0 1.3-.6 1.3-1.3V8c0-.4-.1-.7-.4-.9z"
  }))));
}

export default SvgDownload;